/* eslint-disable jsx-a11y/no-onchange */
import { func, object, oneOfType, shape, string } from "prop-types"
import { isEqual } from "utils/helpers"
import { DatePicker } from "components/ui"
import { StackView } from "@planningcenter/tapestry-react"

const AreaFormAges = ({
  ageRestrictionType,
  onAgeRestrictionChange,
  minAge,
  onMinAgeChange,
  maxAge,
  onMaxAgeChange,
  ageUnit,
  onAgeUnitChange,
  evaluateAgeAt,
  onEvaluateAgeChange,
  validation
}) => {
  return (
    <StackView axis="horizontal" wrap spacing={1} marginBottom={1}>
      <div>
        <label className="screen-reader-text" htmlFor="ageRestrictionType">
          Restrict by Ages
        </label>
        <select
          className="select"
          name="ageRestrictionType"
          value={ageRestrictionType}
          onChange={e => onAgeRestrictionChange(e.target.value)}
        >
          <option value="between">between</option>
          <option value="atLeast">at least</option>
          <option value="atMost">at most</option>
          <option value="exactly">exactly</option>
        </select>
        {validation.minAge && <div className="c-error font-size-5">{validation.minAge}</div>}
      </div>

      {!isEqual(ageRestrictionType, "atMost") && (
        <div css={{ width: 80 }}>
          <label className="screen-reader-text" htmlFor="minAge">
            Minimum age
          </label>
          <input
            className={`${validation.minAge && "error-input"}`}
            type="number"
            name="minAge"
            placeholder={isEqual(ageRestrictionType, "exactly") ? "Age" : "Min Age"}
            value={minAge}
            onChange={e => onMinAgeChange(e.target.value)}
          />
        </div>
      )}

      {isEqual(ageRestrictionType, "between") && <div className="pt-1">and</div>}

      {(isEqual(ageRestrictionType, "between") || isEqual(ageRestrictionType, "atMost")) && (
        <div css={{ width: 80 }}>
          <label className="screen-reader-text" htmlFor="maxAge">
            Maximum age
          </label>
          <input
            className={`${validation.maxAge && "error-input"}`}
            type="number"
            name="maxAge"
            placeholder="Max Age"
            value={maxAge}
            onChange={e => onMaxAgeChange(e.target.value)}
          />
        </div>
      )}

      <div>
        <label className="screen-reader-text" htmlFor="ageUnit">
          Age unit
        </label>
        <select
          className="select"
          name="ageUnit"
          value={ageUnit}
          onChange={e => onAgeUnitChange(e.target.value)}
        >
          <option value={"years"}>years</option>
          <option value={"months"}>months</option>
        </select>
      </div>

      <div className="pt-1">by</div>

      <div>
        <label className="screen-reader-text" htmlFor="evaulateAgeAt">
          Evaluate age on date
        </label>
        <DatePicker onChange={onEvaluateAgeChange} datetime={evaluateAgeAt} />
      </div>
    </StackView>
  )
}

AreaFormAges.propTypes = {
  validation: shape({
    minAge: string,
    maxAge: string
  }),
  ageRestrictionType: string,
  onAgeRestrictionChange: func,
  minAge: string,
  onMinAgeChange: func,
  maxAge: string,
  onMaxAgeChange: func,
  ageUnit: string,
  onAgeUnitChange: func,
  evaluateAgeAt: oneOfType([string, object]),
  onEvaluateAgeChange: func
}

export default AreaFormAges
